module.exports = __webpack_public_path__ + "img/logo.37c733a1.png";